module.exports = __webpack_public_path__ + "img/receed.d9e68d20.svg";